import Box from "common/components/Box";
import { useCallback, useRef, useState } from "react";
import Icon from "react-icons-kit";
import { ic_keyboard_arrow_right } from "react-icons-kit/md/ic_keyboard_arrow_right";
import { ic_keyboard_arrow_left } from "react-icons-kit/md/ic_keyboard_arrow_left";
import { PrismicImage } from "@prismicio/react";
import styled from "styled-components";
import ImgsViewer from "react-images-viewer";

const BoxImage = styled.div`
  position: relative;
  .image_info {
    height: 320px;
    border-radius: 8px;
  }
`;
const ImageContainer = ({ bot_images }) => {
  const chipsContainerRef = useRef(null);
  const [isCanScroll, setIsCanScroll] = useState({
    left: false,
    right: true,
  });
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const SCROLL_AMOUNT = 500;
  const SCROLL_DELAY = 800;
  const isSm = typeof window !== "undefined" && window.innerWidth <= 600;
  const MIN_BOX_FOR_SCROLL = isSm ? 2 : 3;

  const handleScroll = useCallback((direction) => {
    const container = chipsContainerRef.current;
    if (container) {
      const scrollAmount =
        direction === "left" ? -SCROLL_AMOUNT : SCROLL_AMOUNT;
      container.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });

      setTimeout(() => {
        setIsCanScroll({
          left: container.scrollLeft > 0,
          right:
            container.scrollLeft <
            container.scrollWidth - container.clientWidth,
        });
      }, SCROLL_DELAY);
    }
  }, []);
  const openViewer = (index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  };
  const closeViewer = () => setIsViewerOpen(false);

  const arrowStyles = {
    position: "absolute",
    border: "1px solid",
    background: "#fff",
    borderRadius: "50%",
    width: 40,
    display: "flex",
    height: 40,
    transition: "opacity 0.3s",
    top: "45%",
  };

  const gotoPrevImg = () => {
    setCurrentImage((prevImage) =>
      prevImage > 0 ? prevImage - 1 : bot_images?.length - 1
    );
  };

  const gotoNextImg = () => {
    setCurrentImage((prevImage) =>
      prevImage < bot_images?.length - 1 ? prevImage + 1 : 0
    );
  };

  const isRightScrollEnabled =
    isCanScroll.right && bot_images?.length > MIN_BOX_FOR_SCROLL;
  return (
    <BoxImage>
      <div
        ref={chipsContainerRef}
        style={{ position: "relative", overflow: "hidden" }}
      >
        <Box style={{ display: "flex", gap: "30px", marginTop: "20px" }}>
          {bot_images?.map((value, index) => (
            <PrismicImage
              onClick={() => openViewer(index)}
              className="image_info"
              field={value.img}
            />
          ))}
        </Box>
      </div>
      <Box
        style={{
          ...arrowStyles,
          left: 0,

          opacity: isCanScroll.left ? 1 : 0,
        }}
        onClick={() => handleScroll("left")}
      >
        <Icon
          size={30}
          style={{ margin: "auto" }}
          icon={ic_keyboard_arrow_left}
        />
      </Box>
      <Box
        style={{
          ...arrowStyles,
          right: 0,
          opacity: isRightScrollEnabled ? 1 : 0,
        }}
        onClick={() => handleScroll("right")}
      >
        <Icon
          size={30}
          style={{ margin: "auto" }}
          icon={ic_keyboard_arrow_right}
        />
      </Box>

      <div>
        <ImgsViewer
          imgs={bot_images?.map((value) => ({ src: value.img.url }))}
          currImg={currentImage}
          backdropCloseable={true}
          showImgCount={false}
          showCloseBtn={false}
          showThumbnails={false}
          onClickPrev={gotoPrevImg}
          onClickNext={gotoNextImg}
          isOpen={isViewerOpen}
          onClose={closeViewer}
        />
      </div>
    </BoxImage>
  );
};
export default ImageContainer;
